import PropTypes from 'prop-types';
import styles from './Display.module.css';

/**
 * Display - Large hero/heroine text component for impactful headlines
 * Used for hero sections and major page titles
 */
export function Display({
  children,
  as: Component = 'span',
  size = 'xl',
  weight = 'black',
  color = 'primary',
  align = 'left',
  shadow = false,
  gradient = false,
  className = '',
  ...props
}) {
  const classNames = [
    styles.display,
    styles[size],
    styles[weight],
    styles[color],
    styles[align],
    shadow && styles.shadow,
    gradient && styles.gradient,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <Component className={classNames} {...props}>
      {children}
    </Component>
  );
}

Display.propTypes = {
  children: PropTypes.node.isRequired,
  as: PropTypes.elementType,
  size: PropTypes.oneOf(['sm', 'md', 'lg', 'xl', '2xl']),
  weight: PropTypes.oneOf(['normal', 'medium', 'semibold', 'bold', 'extrabold', 'black']),
  color: PropTypes.oneOf(['primary', 'secondary', 'muted', 'cyan', 'lime']),
  align: PropTypes.oneOf(['left', 'center', 'right']),
  shadow: PropTypes.bool,
  gradient: PropTypes.bool,
  className: PropTypes.string,
};

export default Display;
